import * as React from 'react'
import './AssetCard.css'
import '../Icons/ContentTypeIcon.css'
import { BunnyFileDto, CreateFreebieForm } from '../Pages/AdminPages/AdminCampainComps/FreebeeFrom';
import { ContentKeys, contentTypeIconMap, FolderIcon, ImageFolderIcon, OfficeIcon, PdfIcon, VideoFolderIcon } from '../Icons/ContentTypeIcon';
interface AssetCardRenderProps{
    data:BunnyFileDto[];
    item:CreateFreebieForm;
    onClick:(value:BunnyFileDto,propKey:keyof BunnyFileDto) => void;

}
type ContentLabel = 'audio' | 'archives' | 'office' | 'documents' | 'image' | 'video' | 'application'
type FolderTypes = Record<ContentLabel,{label:string,icon:React.ReactNode,files:BunnyFileDto[]}>;
const LABEL_MAP: Record<ContentLabel,{ label:string,icon:React.ReactNode}> = {
  audio: {label:'Ljud',icon:<FolderIcon label='Ljud'></FolderIcon>},
  archives: {label:'Zip',icon:<FolderIcon label='Zip'></FolderIcon>},
  office: {label:'Office',icon:<FolderIcon label='Office' className='office'><OfficeIcon/></FolderIcon>},
  documents: {label:'Dokument',icon:<FolderIcon label='Dokument' childClassName='pdf'><PdfIcon/></FolderIcon>},
  application: {label:'Dokument',icon:<FolderIcon label='Dokument' childClassName='pdf'><PdfIcon/></FolderIcon>},
  image: {label:'Bilder',icon:<FolderIcon label='Bilder' childClassName='pdf'><ImageFolderIcon/></FolderIcon>},
  video: {label:'Video',icon:<FolderIcon label='Videos' childClassName='pdf'><VideoFolderIcon/></FolderIcon>}
}

export const AssetCardRender = ({data,item,onClick}:AssetCardRenderProps) => {
  // Audio
   // Archives
   // Office
    // Documents
    // Image
    // Video
    const [activeFolder, setActiveFolder] =
  React.useState<ContentLabel | null>(null);
 const folders = React.useMemo(() => {
  return data.reduce<Partial<FolderTypes>>((acc, item) => {
    const type = item?.contentType
    if (!type) return acc

    const label = (
      ['audio', 'archives', 'office', 'documents', 'image', 'video','application'] as ContentLabel[]
    ).find(l => type.includes(l))

    if (!label) return acc

    if (!acc[label]) {
      acc[label] = {
        label: LABEL_MAP[label].label,
        icon:LABEL_MAP[label].icon,
        files: []
      }
    }

    acc[label]!.files.push(item)

    return acc
  }, {})
}, [data])
  
    return(
      <>
      <div className='folder-container'>
 {folders &&
  (Object.entries(folders) as [ContentLabel, FolderTypes[ContentLabel]][])
    .map(([key, folder]) => {
      if (!folder) return null;
       const isSelected = activeFolder === key;
      return (
        <div key={key} onClick={() => setActiveFolder(key)}
          className={`folder-tile ${isSelected ? "is-selected" : ""}`}>
          {folder.icon}
        </div>
      );
    })}
      </div>
<div className="file-grid">
 
  {activeFolder && 
    folders?.[activeFolder]?.files.map(file => {
    const isSelected = item.fileUrl === file.url;

    return (
      <div
        key={file.url}
        onClick={() => onClick(file,'url')}
        className={`file-card ${isSelected ? "is-selected" : ""}`}
      >
        <div className="file-preview">
          <span className="file-icon">
            {/* {file.contentType === "Videos"
              ? "🎬"
              : file.fileName.endsWith(".pdf")
              ? "📕"
              : "🖼️"} */}
              {contentTypeIconMap[file.contentType as ContentKeys]}
          </span>

          <div className="selection-indicator">
            {isSelected && <span>✓</span>}
          </div>
        </div>

        <div className="file-meta">
          <div className="file-name">{file.fileName}</div>
          <div className="file-footer">
            <span className="file-size">{file.fileSizeBytes}</span>
            <span className="file-action">
              {isSelected ? "Vald" : "Välj"}
            </span>
          </div>
        </div>
      </div>
    );
  })}
</div>
</>
    );
}